/**
 * Mapping entre les anciens noms de tabs et les nouvelles routes React Router
 */
export const routeMap = {
  'home': '/home',
  'pointage-geo': '/pointage',
  'geolocation-admin': '/admin/gps',
  'audit-photos': '/admin/audit-photos',
  'historique': '/historique',
  'calendrier': '/calendrier',
  'planning': '/planning',
  'ideas': '/ideas',
  'communiques': '/communiques',
  'dashboard': '/dashboard',
  'employees': '/employees',
  'reports': '/rapports',
  'badges': '/badges',
  'formations': '/formations',
  'notes-frais': '/notes-frais',
  'leaves': '/conges',
  'soldes': '/soldes',
  'documents': '/documents',
  'profil': '/profil',
  'aide': '/aide',
  'billing': '/facturation',
  'billing-plans': '/facturation/plans',
  'billing-success': '/facturation/success',
  'payroll': '/paie',
  'performance': '/performance',
  'admin-panel': '/admin',
  'admin-dashboard': '/admin/dashboard',
  'super-admin': '/super-admin'
};

/**
 * Reverse mapping: route → tab name
 */
export const tabMap = Object.entries(routeMap).reduce((acc, [tab, route]) => {
  acc[route] = tab;
  return acc;
}, {});

/**
 * Convertit un nom de tab en route React Router
 */
export const tabToRoute = (tab) => {
  return routeMap[tab] || '/home';
};

/**
 * Convertit une route React Router en nom de tab
 */
export const routeToTab = (route) => {
  // Nettoyer la route (enlever les query params)
  const cleanRoute = route.split('?')[0];
  return tabMap[cleanRoute] || 'home';
};

/**
 * Helper pour créer une fonction onNavigate compatible avec les composants existants.
 * Si l'argument commence par "/", c'est une route directe (ex: /employees/import), sinon on utilise routeMap.
 */
export const createNavigateWrapper = (navigate) => {
  return (tab) => {
    const route = (typeof tab === 'string' && tab.startsWith('/')) ? tab : tabToRoute(tab);
    navigate(route);
  };
};



